export default {
  common: {
    loading: "جارٍ التحميل...",
  },
  header: {
    openMenu: "فتح القائمة",
    home: "الرئيسية",
    language: "اللغة",
    searchPlaceholder: "ابحث عن صفحة...",
    searchLabel: "ابحث عن صفحة",
    noResult: "لا توجد نتائج",
    notifications: "الإشعارات",
    notificationsUnread: "الإشعارات، {count} غير مقروءة",
    markAllRead: "تعليم الكل كمقروء",
    noNotifications: "لا توجد إشعارات",
    onlineAccount: "الحساب متصل",
    myAccount: "حسابي",
    myProfile: "ملفي الشخصي",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    roleAdmin: "مسؤول",
    roleClient: "عميل",
    roleDriver: "عامل التوصيل",
    roleZoneManager: "مسؤول المنطقة",
    justNow: "الآن",
    minutesAgo: "منذ {n} دقيقة",
    hoursAgo: "منذ {n} ساعة",
  },
  theme: {
    enableLight: "تفعيل الوضع الفاتح",
    enableDark: "تفعيل الوضع الداكن",
    light: "الوضع الفاتح",
    dark: "الوضع الداكن",
  },
  sidebar: {
    mainNav: "التنقل الرئيسي",
    mainMenu: "القائمة الرئيسية",
    closeMenu: "إغلاق القائمة",
    loadingMenu: "جارٍ تحميل القائمة",
  },
  menu: {
    dashboard: "لوحة التحكم",
    parcels: "الطرود",
    addParcel: "طرد جديد",
    parcelsList: "قائمة الطرود",
    pickupParcels: "طرود للاستلام",
    followups: "المتابعة والتذكير",
    exchanges: "الاستبدالات",
    importParcels: "استيراد الطرود",
    inventory: "المخزون",
    productsList: "قائمة المنتجات",
    stockParcels: "طرود المخزون",
    deliveryNotes: "وصولات التسليم",
    addDeliveryNote: "وصل تسليم جديد",
    myInvoices: "فواتيري",
    refunds: "الاستردادات",
    newRequest: "طلب جديد",
    myRequests: "طلباتي",
    balanceHistory: "سجل الرصيد",
    returnNotes: "وصولات الإرجاع",
    claims: "الشكايات",
    pickup: "الاستلام من العميل",
    users: "المستخدمون",
    subAccounts: "الحسابات الفرعية",
    blackList: "القائمة السوداء",
    apiDocs: "توثيق API",
    myDocuments: "وثائقي",
    ribChange: "تغيير RIB",
    phoneChange: "تغيير الهاتف",
    webhooks: "Webhooks",
    profile: "الملف الشخصي",
  },
  account: {
    activeAccount: "الحساب النشط: {name}",
    switchHint: " — تغيير الحساب",
    subAccountOf: "حساب فرعي · {name}",
    mainAccount: "الحساب الرئيسي",
    subAccount: "حساب فرعي",
    inactive: "غير نشط",
    switchAccount: "تغيير الحساب",
    allAccounts: "جميع الحسابات",
    manageSubAccounts: "إدارة الحسابات الفرعية",
    enterFailed: "تعذر الدخول إلى هذا الحساب",
  },
};
